import { getScoreColor, getTextColor } from '../../../utilities/common/color';
import ScoreBar from '../ScoreBar';
import GrowthStat from '../utils/GrowthStat';
import { WidgetDefinition } from '../../../shared/types/widget';

interface BenchmarkScoreCardProps {
  definition: WidgetDefinition;
  content: any;
}

function BenchmarkScoreCard({ definition, content }: BenchmarkScoreCardProps) {
  return (
    <>
      <div className="divide-black-200 flex divide-x overflow-auto px-6 py-[36px] lg:gap-x-16">
        <div className="mb-3 flex gap-x-4 pr-16 leading-[60px] font-medium md:text-[42px] lg:text-[64px]">
          <div className="flex flex-col">
            <p
              className={`text-[64px] whitespace-nowrap ${getTextColor(
                getScoreColor(content?.data?.value, content?.data?.benchmark),
              )}`}
            >
              {content?.data?.value}/ 100
            </p>
            {content?.data?.growth && (
              <GrowthStat score={+content?.data?.growth} />
            )}
          </div>
        </div>
        <div className="w-full px-16">
          <ScoreBar
            data={{
              score: content?.data?.value,
              benchmark: content?.data?.benchmark,
            }}
          />
        </div>
      </div>
    </>
  );
}

export default BenchmarkScoreCard;
